import React from 'react'
import {TemplateTextContent} from "./TemplateTextContent";

const TemplateThree = ({activeTemplate, toggleModal, content, image1, buttonComp, displayEditContentButton, publishActiveTemplate, canCustomize }) => {
    return (
        <div className='row template_three'>
            <div className={`col-md-6 col-sm-12 `}>
              <TemplateTextContent
                toggleModal={toggleModal}
                content={content}
                buttonComp={buttonComp}
                displayEditContentButton={displayEditContentButton}
                activeTemplate={activeTemplate}
                publishActiveTemplate={publishActiveTemplate}
                canCustomize={canCustomize}
              />
            </div>
            <div className={`col-md-6 col-sm-12 `}>
                <figure className='figure_img aside'>
                    <picture style={{ backgroundImage: `url('${image1}')` }}></picture>
                </figure>
            </div>
        </div>
    )
}

export default TemplateThree
